import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-97f5685a")

_pushScopeId("data-v-97f5685a")
const _hoisted_1 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_list_row = _resolveComponent("list-row")
  const _component_vue_y_scroll_area = _resolveComponent("vue-y-scroll-area")
  const _component_vue_content = _resolveComponent("vue-content")

  return (_openBlock(), _createBlock(_component_vue_content, null, {
    default: _withId(() => [
      (_ctx.favoriteRows.length===0)
        ? (_openBlock(), _createBlock("div", _hoisted_1, "ブックマークはありません"))
        : (_openBlock(), _createBlock(_component_vue_y_scroll_area, { key: 1 }, {
            default: _withId(() => [
              _createVNode(_TransitionGroup, null, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.favoriteRows, (row) => {
                    return (_openBlock(), _createBlock(_component_list_row, {
                      key: row.id,
                      rowId: row.id,
                      columns: row.columns,
                      class: "consultation-list-row"
                    }, null, 8, ["rowId", "columns"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
    ]),
    _: 1
  }))
})